import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { OverlayTrigger, Tooltip, Modal, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import Axios from "axios";
import { updateStatus } from '../apiconstants/constants';

const CandidateLayout1 = ({
  title,
  candidateGuid,
  fullName,
  email,
  extraRight,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [showMailModal, setShowMailModal] = useState(false);
  const [candidateId, setCandidateId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({
    sendJobDetails: false,
    sendRTR: false,
    sendFollowup: false,
    sendRelocate: false,
    sendSubmission: false,
  });
const [selectedCandidate, setSelectedCandidate] = useState({ fullName: "", email: "",guid:"" });
  const currentSearch = location.search || (candidateGuid ? `?guid=${candidateGuid}` : "");
  const guidQuery = candidateGuid ? `?guid=${candidateGuid}` : currentSearch;
  const handleDeactivateCandidate = (id) => {
    setCandidateId(id);
    setShowModal(true);
  };
const token = localStorage.getItem("jwtToken");
  const handleConfirmDeactivation = async () => {
    const params = { userGuid: candidateId };

    try {
      setIsLoading(true);
      const result = await Axios.put(`${updateStatus.APIURL}?Guid=${candidateId}&isActive=false`, params,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      if (result.data === 'Candidate status updated successfully') {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Deactivated successfully',
          showConfirmButton: false,
          timer: 2000,
        });

        setIsLoading(false);
        setShowModal(false);
      }
    } catch (error) {
      console.log("Error", error);
      setIsLoading(false);
    }
  };

  const handleCancel = () => setShowModal(false);

  const handleMailRadioChange = (e) => {
    const { value } = e.target;
    setSelectedOptions({
      sendJobDetails: value === "sendJobDetails",
      sendRTR: value === "sendRTR",
      sendFollowup: value === "sendFollowup",
      sendRelocate: value === "sendRelocate",
      sendSubmission: value === "sendSubmission",
    });
  };

 const handleConfirm = () => {
  const { fullName, email, guid } = selectedCandidate;  // destructure guid too

let emailType  = "jobdetails"; // default

  if (selectedOptions.sendRTR) emailType  = "rtr";
  else if (selectedOptions.sendFollowup) emailType  = "followup";
  else if (selectedOptions.sendRelocate) emailType  = "Relocate";
 else if (selectedOptions.sendSubmission) emailType  = "Submission";
  navigate('/Employer/SendEmail', {
    state: {
      fullName,
      candidateGuid:guid,   // pass correct GUID
      candidateEmail:email,
      emailType,
    },
  });

  setShowMailModal(false); // close modal
};


  return (
    <div className="d-flex align-items-center justify-content-between mb-2 mt-2">
    
      <div className="d-flex align-items-center">
        <Link to="/Employer/InternalBench">
                            <i className="fa fa-arrow-left mr-3" style={{ color: "#00a7ac", fontSize: 16 }} aria-hidden="true"></i>
                        </Link>
        <h2 className="m-0" style={{ color: "#00a7ac" }}>{title}</h2>
      </div>
      <div className="d-flex align-items-center">
        {/* View */}
        <Link
          to={`/Employer/BenchViewCandidateDetailsByCandidateGUid${guidQuery}`}
          className="btn btn-light mr-2"
          title="View"
          style={{ borderColor: "#00a7ac", color: "#00a7ac" }}
        >
          <i className="fa fa-eye"></i>
        </Link>

        {/* Edit */}
        <Link
          to={`/Employer/EditInternalCandidate${guidQuery}`}
          className="btn btn-light mr-2"
          title="Edit"
          style={{ borderColor: "#00a7ac", color: "#00a7ac" }}
        >
          <i className="fa fa-edit"></i>
        </Link>

      
       
        {/* Deactivate
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="tooltip-deactivate">Deactivate Candidate</Tooltip>}
        >
          <button
            onClick={() => handleDeactivateCandidate(candidateGuid)}
            className="btn btn-light mr-2"
            title="Deactivate"
            style={{ borderColor: "#00a7ac", color: "#00a7ac" }}
          >
            <i className="fa fa-user-slash"></i>
          </button>
        </OverlayTrigger> */}

      
       

        {extraRight}
      </div>

      {/* Deactivation Modal */}
      <Modal show={showModal} centered onHide={handleCancel}>
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#00a7ac" }}>Confirm Deactivation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to deactivate this candidate?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancel}>No</Button>
          <Button variant="primary" onClick={handleConfirmDeactivation} disabled={isLoading}>
            {isLoading ? "Deactivating..." : "Yes"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Email Modal */}
      <Modal
        show={showMailModal}
        onHide={() => setShowMailModal(false)}
        dialogClassName="custom-modal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#00a7ac" }}>Select Email Options</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-check text-start ml-5">
            <input
              className="form-check-input"
              type="radio"
              name="mailType"
              value="sendJobDetails"
              checked={selectedOptions.sendJobDetails}
              onChange={handleMailRadioChange}
              id="sendJobDetails"
            />
            <label className="form-check-label" htmlFor="sendJobDetails">
              Send Job Details Mail
            </label>
          </div>

          <div className="form-check mt-2 text-start ml-5">
            <input
              className="form-check-input"
              type="radio"
              name="mailType"
              value="sendRTR"
              checked={selectedOptions.sendRTR}
              onChange={handleMailRadioChange}
              id="sendRTR"
            />
            <label className="form-check-label" htmlFor="sendRTR">
              Send RTR Mail
            </label>
          </div>

          <div className="form-check mt-2 text-start ml-5">
            <input
              className="form-check-input"
              type="radio"
              name="mailType"
              value="sendFollowup"
              checked={selectedOptions.sendFollowup}
              onChange={handleMailRadioChange}
              id="sendFollowup"
            />
            <label className="form-check-label" htmlFor="sendFollowup">
              Send Follow Up Mail
            </label>
          </div>

          <div className="form-check mt-2 text-start ml-5">
            <input
              className="form-check-input"
              type="radio"
              name="mailType"
              value="sendRelocate"
              checked={selectedOptions.sendRelocate}
              onChange={handleMailRadioChange}
              id="sendRelocate"
            />
            <label className="form-check-label" htmlFor="sendRelocate">
              Send Relocation Confirmation Mail
            </label>
          </div>


           <div className="form-check mt-2 text-start ml-5">
            <input
              className="form-check-input"
              type="radio"
              name="mailType"
              value="sendSubmission"
              checked={selectedOptions.sendSubmission}
              onChange={handleMailRadioChange}
              id="sendSubmission"
            />
            <label className="form-check-label" htmlFor="sendSubmission">
              Send Submission Details to Candidate Mail
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleConfirm}>Proceed</Button>
          <Button variant="secondary" onClick={() => setShowMailModal(false)}>Cancel</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CandidateLayout1;
